import { render, staticRenderFns } from "./user-friend.vue?vue&type=template&id=321026d2&scoped=true"
import script from "./user-friend.vue?vue&type=script&lang=js"
export * from "./user-friend.vue?vue&type=script&lang=js"
import style0 from "./user-friend.vue?vue&type=style&index=0&id=321026d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321026d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321026d2')) {
      api.createRecord('321026d2', component.options)
    } else {
      api.reload('321026d2', component.options)
    }
    module.hot.accept("./user-friend.vue?vue&type=template&id=321026d2&scoped=true", function () {
      api.rerender('321026d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-friend.vue"
export default component.exports